import StockMovementQueries from './StockMovementQueries'

const mvStockMovement = {
  mvStockMovement: {
    ...StockMovementQueries,
  }
}

export default mvStockMovement